import { TextAreaBox } from './TextAreaBox';

export default TextAreaBox;
